/** Static wiring of the Nara platform, today and as a target. Copy lives in i18n under `architecture.<diagram>.nodes.<id>`. */

export type ArchitectureLayer = "clients" | "entry" | "hub" | "machine" | "signin" | "data";

export type ArchitectureNode = {
  id: string;
  layer: ArchitectureLayer;
  x: number;
  y: number;
  /** An access-decision node: coloured the same way in both diagrams. */
  decision?: boolean;
};

export type ArchitectureDiagram = {
  nodes: ArchitectureNode[];
  edges: [from: string, to: string][];
};

const ROW = 140;
const COL = 240;

const clients = (hubId: string): ArchitectureNode[] =>
  [hubId, "ios", "android", "agents"].map((id, i) => ({ id, layer: "clients", x: i * COL, y: 0 }));

export const TODAY: ArchitectureDiagram = {
  nodes: [
    ...clients("web"),
    { id: "door", layer: "entry", x: 1.5 * COL, y: ROW },
    { id: "hosting", layer: "hub", x: 0, y: 2 * ROW },
    { id: "functions", layer: "hub", x: COL, y: 2 * ROW },
    { id: "gate", layer: "hub", x: 2 * COL, y: 2 * ROW, decision: true },
    { id: "identity", layer: "signin", x: 3 * COL, y: 2 * ROW },
    { id: "core", layer: "machine", x: COL, y: 3 * ROW, decision: true },
    { id: "services", layer: "machine", x: 2 * COL, y: 3 * ROW },
    { id: "sql", layer: "data", x: 1.5 * COL, y: 4 * ROW },
  ],
  edges: [
    ["web", "door"], ["ios", "door"], ["android", "door"], ["agents", "door"],
    ["door", "hosting"], ["door", "functions"],
    ["functions", "gate"], ["functions", "identity"],
    ["gate", "core"], ["gate", "services"],
    ["core", "sql"], ["services", "sql"],
  ],
};

export const TARGET: ArchitectureDiagram = {
  nodes: [
    ...clients("web"),
    { id: "door", layer: "entry", x: 1.5 * COL, y: ROW },
    { id: "hub", layer: "hub", x: 0, y: 2 * ROW },
    { id: "authority", layer: "machine", x: COL, y: 2 * ROW, decision: true },
    { id: "identity", layer: "signin", x: 2 * COL, y: 2 * ROW },
    { id: "services", layer: "machine", x: COL, y: 3 * ROW },
    { id: "sql", layer: "data", x: COL, y: 4 * ROW },
  ],
  edges: [
    ["web", "hub"],
    ["web", "door"], ["ios", "door"], ["android", "door"], ["agents", "door"],
    ["door", "authority"], ["authority", "identity"],
    ["authority", "services"], ["services", "sql"],
  ],
};
